import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import { openSnackbar } from 'slices/snackbar';
import { logout } from 'slices/auth';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseApi,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (user) => ({
        url: '/auth/login',
        method: 'POST',
        body: user
      })
    }),
    setNewPassword: builder.mutation({
      query: ({ userId, ...attributes }) => ({
        url: `/auth/reset-password`,
        method: 'POST',
        body: { userId, ...attributes }
      })
    }),
    getRole: builder.query({
      query: () => '/users/role',
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.data?.status === 0) {
            dispatch(
              openSnackbar({
                open: true,
                message: 'Access has been revoked. Redirecting to login.',
                variant: 'alert',
                alert: {
                  severity: 'error',
                  color: 'error'
                },
                close: false
              })
            );
            dispatch(logout());
          }
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    })
  })
});

export const { useLoginMutation, useSetNewPasswordMutation, useGetRoleQuery } = authApi;
